export enum ContractTypeV2 {
    FULLTIME = 'FULLTIME',
    PARTTIME = 'PARTTIME',
    SEASONAL = 'SEASONAL',
    GIG = 'GIG',
    INTERNSHIP = 'INTERNSHIP',
}
